export default __webpack_public_path__ + "static/media/error.dd24d205.png";